'use client';

import { useState } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';
import { useLanguage } from '@/contexts/LanguageContext';




interface HeaderProps {
  className?: string;
}

const Header = ({ className = '' }: HeaderProps) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { language, setLanguage, t } = useLanguage();

  const menuItems = [
  { label: t('common.home'), href: '/', icon: 'ChartBarIcon' },
  { label: t('common.dailyDeals'), href: '/daily-deals-completed', icon: 'CurrencyDollarIcon' },
  { label: t('common.clientSuccess'), href: '/client-success-gallery', icon: 'StarIcon' },
  { label: t('common.trackRecord'), href: '/about-our-track-record', icon: 'TrophyIcon' },
  { label: t('common.getStarted'), href: '/get-started', icon: 'RocketLaunchIcon' }];



  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'es' : 'en');
  };

  return (
    <header className={`bg-card shadow-md fixed top-0 left-0 right-0 z-50 ${className}`}>
      <div className="w-full">
        <div className="flex items-center justify-between h-14 px-4 lg:px-6">
          <Link href="/" className="flex items-center bg-transparent">
            <AppImage
              src="/assets/images/Untitled-1770917634507.jpeg"
              alt="Rapida Inversion Logo"
              width={640}
              height={177}
              className="h-12 w-auto object-contain bg-transparent"
              style={{
                filter: 'brightness(1.3) contrast(1.3) saturate(1.1)',
                fontWeight: 'bold',
                WebkitFontSmoothing: 'antialiased',
                backgroundColor: 'transparent'
              }} />

          </Link>

          <nav className="hidden lg:flex items-center space-x-0.5">
            {menuItems.map((item) =>
            <Link
              key={item.href}
              href={item.href}
              suppressHydrationWarning
              className="flex items-center space-x-1 px-2 py-1.5 rounded-md text-xs font-medium text-foreground hover:bg-muted hover:text-primary transition-all duration-300 ease-out">

                <Icon name={item.icon as any} size={14} variant="outline" className="border-none" />
                <span>{item.label}</span>
              </Link>
            )}
          </nav>

          <div className="hidden lg:flex items-center space-x-2">
            {/* Language Switcher */}
            <button
              onClick={toggleLanguage}
              className="flex items-center space-x-1 px-3 py-1.5 rounded-md text-xs font-medium text-foreground hover:bg-muted transition-all duration-300 ease-out border border-border">
              <Icon name="LanguageIcon" size={14} variant="outline" />
              <span className="font-semibold">{language === 'en' ? 'ES' : 'EN'}</span>
            </button>

            <Link
              href="/get-started"
              className="px-4 py-1.5 bg-cta text-cta-foreground rounded-md font-heading font-semibold text-xs hover:bg-opacity-90 transition-all duration-300 ease-out shadow-card hover:shadow-hover transform hover:-translate-y-0.5">

              {t('common.getStarted')}
            </Link>
          </div>

          <button
            onClick={toggleMobileMenu}
            className="lg:hidden p-2 rounded-md text-foreground hover:bg-muted transition-colors duration-300"
            aria-label="Toggle mobile menu">

            <Icon
              name={isMobileMenuOpen ? 'XMarkIcon' : 'Bars3Icon'}
              size={20}
              variant="outline" />

          </button>
        </div>

        {isMobileMenuOpen &&
        <div className="lg:hidden bg-card border-t border-border">
            <nav className="flex flex-col px-4 py-2 space-y-1">
              {menuItems.map((item) =>
            <Link
              key={item.href}
              href={item.href}
              onClick={() => setIsMobileMenuOpen(false)}
              suppressHydrationWarning
              className="flex items-center space-x-2 px-3 py-2 rounded-md text-xs font-medium text-foreground hover:bg-muted hover:text-primary transition-all duration-300 ease-out">

                  <Icon name={item.icon as any} size={16} variant="outline" />
                  <span>{item.label}</span>
                </Link>
            )}

              {/* Mobile Language Switcher */}
              <button
                onClick={toggleLanguage}
                className="flex items-center space-x-2 px-3 py-2 rounded-md text-xs font-medium text-foreground hover:bg-muted transition-all duration-300 ease-out border border-border">
                <Icon name="LanguageIcon" size={16} variant="outline" />
                <span>{language === 'en' ? 'Español' : 'English'}</span>
              </button>

              <Link
                href="/get-started"
                onClick={() => setIsMobileMenuOpen(false)}
                suppressHydrationWarning
                className="flex items-center justify-center px-4 py-2 mt-2 bg-cta text-cta-foreground rounded-md font-heading font-semibold text-xs hover:bg-opacity-90 transition-all duration-300 ease-out">

                {t('common.getStarted')}
              </Link>
            </nav>
          </div>
        }
      </div>
    </header>);

};

export default Header;